import { MaskedLines, Reveal } from "./MaskedLines";
import { BlockArea } from "@/components/cms/BlockArea";

export const LegalPage = ({ testId, title, updated, sections, theme = "site" }) => {
  const isChannel = theme === "channel";
  return (
  <div data-testid={testId} className={`mx-auto ${isChannel ? "max-w-4xl px-0 pt-8 pb-12 sm:pt-10" : "max-w-7xl px-5 pt-10 pb-28 sm:px-8 sm:pt-16 lg:px-12"}`}>
    <p className={`font-mono-label text-xs uppercase tracking-[0.25em] ${isChannel ? "text-white/55" : "text-[#57534E]"}`}>Last updated {updated}</p>
    <MaskedLines lines={[title]} className={`mt-4 font-display font-extrabold ${isChannel ? "text-4xl leading-tight sm:text-5xl" : "text-5xl leading-[0.95] tracking-[-0.04em] sm:text-7xl"}`} />
    <div className={`mt-10 ${isChannel ? "max-w-3xl" : "mt-16 max-w-3xl"}`}>
      {sections.map(([h, body], i) => (
        <Reveal key={h}>
          <section className={`border-t py-8 ${isChannel ? "border-white/15" : "border-black/15"}`}>
            <h2 className={`flex gap-4 text-lg font-extrabold ${isChannel ? "text-white" : "text-black"}`}><span className="font-mono-label text-sm text-[#E62314]">{String(i + 1).padStart(2, "0")}</span>{h}</h2>
            {(Array.isArray(body) ? body : [body]).map((t) => (
              <p key={t.slice(0, 24)} className={`mt-3 text-base leading-relaxed ${isChannel ? "text-white/70" : "text-[#2A2928]"}`}>{t}</p>
            ))}
          </section>
        </Reveal>
      ))}
    </div>
    <BlockArea slug={testId.replace("-page", "")} className={`mt-10 !px-0 ${isChannel ? "text-white" : ""}`} />
  </div>
  );
};
